import {Command} from "./Command";
import {GamePlay} from "../model/game-play";
import {SwitchTeamsCommand} from "./SwitchTeamsCommand";
import {SetScoringPlayCommand} from "./SetScoringPlayCommand";
import {GameService} from "../services/game.service";
import {PlayResult} from "../model/playResult";
import {SetYardLineCommand} from "./SetYardLineCommand";
import {SetDistanceCommand} from "./SetDistanceCommand";
import {SetDownCommand} from "./SetDownCommand";
import {Down} from "../model/down";
import {SetGainCommand} from "./SetGainCommand";
import {
  DEFAULT_FIRST_DOWN_DISTANCE,
  DEFAULT_YARD_LINE,
  getDistance,
  SF
} from "../helpers/distance";
import { HttpClient } from "@angular/common/http";

export class SafetyCommand implements Command {
  private commands: Command[] = [];

  constructor(
    private gamePlay: GamePlay,
    private nextGamePlay: GamePlay,
    private game: GameService,
    private result: PlayResult,
    private http: HttpClient
  ) { }

  execute() {
    let gain = 0
    console.log('COMMAND SafetyCommand')

    if (this.result !== PlayResult.InterceptionSafety) {
      gain = getDistance(this.gamePlay.yardLine, SF)
    }

    if (![PlayResult.SafetyReceivingTeam, PlayResult.InterceptionSafety].includes(this.result)) {
      this.commands.push(
        new SwitchTeamsCommand(this.nextGamePlay, this.gamePlay)
      )
    }

    this.commands.push(
      new SetScoringPlayCommand(this.gamePlay, this.game.game, this.result, this.http, this.game),
      new SetYardLineCommand(this.nextGamePlay, DEFAULT_YARD_LINE.toString()),
      new SetDistanceCommand(this.nextGamePlay, DEFAULT_FIRST_DOWN_DISTANCE),
      new SetDownCommand(this.nextGamePlay, Down.D1),
      new SetGainCommand(this.gamePlay, gain),
    )
    for (const command of this.commands) {
      command.execute();
    }
  }
}
